<template>
    <gz-auth-view-template>
        <GZ-PageTitle title="Добавить адрес" slot="title"/>        
        <GZ-StaticNotification slot="notification"/>
        <Address slot="content"/>
    </gz-auth-view-template>
</template>

<script>
import Address from '@/components/custom/admin/forms/add-address/Address'

export default {
    name: 'AdminAddAddressesView',

    components: {
        Address
    }
}
</script>